export enum CampaignEvents {
  COMPLETE_REGISTRATION = 'af_complete_registration',
  COMPLETE_BOOK_OFFER = 'af_complete_book_offer',
  OPEN_APP = 'af_open_app',
  UNDERAGE_USER = 'af_underage_user',
}
